


















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import MaterialCard from '@/components/material/Card/index.vue';
import { AppModule } from '@/store/modules/app';
import {
  TicketSetting,
  PlanSetting,
  IssuingRule,
  IssuingRuleId,
  IPlanSummaryData,
  IssuableDate,
  IssuableDateBaseDateTypeEnum,
  IDate,
  TimePeriod,
  TimePeriodUnitEnum,
  PlanSettingPrintSpecType,
  LanguageEnum,
  MogiriSettingPlanExtendedInfo,
} from '@/api/types';
import {
  listTicketSettings,
  IGetPlanSettingRequest,
  getPlanSetting,
  IPutPlanSettingRequest,
  putPlanSetting,
  IListPlansRequest,
  listPlans,
} from '@/api/tickets';
import {
  formatApiError,
  compareString,
  stringToIDate,
  stringFromIDate,
  formatDate,
  stringToNumber,
  supportedMogiriSettingPlanLocaledExtendedInfoLangs,
} from '@/utils/index';
import { planToText } from '@/utils/tickets';

type ItemType = {
  text: string;
  value: string;
};

type WithIssuableDates = {
  issuableFromDates: string[];
  issuableFromOptDates: string[];
  issuableToDates: string[];
  issuableToOptDates: string[];
};

type WithIsActive = {
  isActive: boolean;
};

@Component({
  name: 'PlanSettingDetail',
  components: {
    MaterialCard,
  },
})
export default class extends Vue {
  @Prop({ required: true }) private id!: string;
  private planSetting = {} as PlanSetting;
  private planTitle = '';
  private loading = true;
  private editing = false;
  private valid = false;
  private editingPlanSetting = {} as PlanSetting &
    WithIssuableDates &
    WithIsActive;
  private hasBookingDetailBgcolor = false;
  private langItems: ItemType[] = [];
  private plansByPlanId: Map<string, IPlanSummaryData> = new Map();
  private planItems: ItemType[] = [];
  private fromDateMenus: boolean[] = [];
  private fromOptDateMenus: boolean[] = [];
  private toDateMenus: boolean[] = [];
  private toOptDateMenus: boolean[] = [];
  private dialog = false;
  private dialogConfirmHandler = this.resetDialog;
  private dialogTextTitle = '';
  private dialogTextFooter = '';
  private enableMogiri = true;
  private tickets: TicketSetting[] = [];

  get ticketItems() {
    return this.tickets.map(ticket => ({
      text: ticket.title + '|' + ticket.planId + '|' + ticket.unitId,
      value: ticket.id,
    }));
  }

  get isDialogFullscreen() {
    return false && this.$vuetify.breakpoint.smAndDown;
  }

  get canDisplayResult() {
    return !!this.planSetting && !!this.planSetting.id && !this.loading;
  }

  get canDisplayNoData() {
    return (!this.planSetting || !this.planSetting.id) && !this.loading;
  }

  get noDataText() {
    return this.$t('No {msg}', {
      msg: (this.$t('Plan setting') as string).toLowerCase(),
    });
  }

  get issuingRuleItems() {
    return Object.values(IssuingRuleId)
      .filter(
        r =>
          (r as IssuingRuleId) !== IssuingRuleId.UNKNOWN_RULE &&
          (r as IssuingRuleId) !==
            IssuingRuleId.MUST_ISSUE_AFTER_SPECIFIC_TICKET
      )
      .map(r => ({
        text: this.$t(`IssuingRuleId.${r}`),
        value: r as string,
      }));
  }

  get issuableDateBaseItems() {
    return Object.values(IssuableDateBaseDateTypeEnum)
      .filter(
        b =>
          (b as IssuableDateBaseDateTypeEnum) !==
          IssuableDateBaseDateTypeEnum.UNKNOWN_DATE
      )
      .map(b => ({
        text: this.$t(`IssuableDateBaseDateTypeEnum.${b}`),
        value: b as string,
      }));
  }

  get timePeriodUnitItems() {
    return Object.values(TimePeriodUnitEnum)
      .filter(u => (u as TimePeriodUnitEnum) !== TimePeriodUnitEnum.UNKNOWN)
      .map(u => ({
        text: this.$t(`TimePeriodUnitEnum.${u}`),
        value: u as string,
      }));
  }

  get printSpecTypeItems() {
    return Object.values(PlanSettingPrintSpecType).map(t => ({
      text: this.$t(`PlanSettingPrintSpecType.${t}`),
      value: t as string,
    }));
  }

  get canUpdatePlan() {
    return false;
  }

  get canUpdateUnit() {
    return false;
  }

  get canUpdate() {
    return this.valid;
  }

  created() {
    this.fetchData();
    this.loadLangItems();
  }

  private loadLangItems() {
    const langItems: ItemType[] = [];
    supportedMogiriSettingPlanLocaledExtendedInfoLangs.forEach(l => {
      langItems.push({
        value: l,
        text: this.$t(`LanguageEnum.${l}`) as string,
      });
    });
    this.langItems = langItems;
  }

  private async fetchThenLoadTicketSetting() {
    try {
      const res = await listTicketSettings({});
      this.tickets = res.tickets;
    } catch (err) {
      this.$toast.error(
        this.$t('Failed to {do} due to {err}', {
          do: (this.$t('Fetch {msg}', {
            msg: this.$t('Ticket setting'),
          }) as string).toLowerCase(),
          err: formatApiError(this.$i18n, err),
        }) as string,
        {
          icon: 'mdi-alert',
        }
      );
    }
  }

  private async fetchData(noLoading = false) {
    if (!noLoading) {
      this.loading = true;
      AppModule.StartProgress();
    }

    await Promise.all([
      this.fetchThenLoadPlans(),
      this.fetchThenLoadPlanSetting(),
      this.fetchThenLoadTicketSetting(),
    ]);

    if (!noLoading) {
      this.loading = false;
      AppModule.StopProgress();
    }
  }

  private async fetchThenLoadPlans() {
    const res = await listPlans({});
    this.plansByPlanId = new Map(res.plans.map(p => [p.planId, p]));

    const planItems: ItemType[] = [];
    this.plansByPlanId.forEach(p => {
      planItems.push({
        text: planToText(this.$i18n, p),
        value: p.planId,
      });
    });
    this.planItems = planItems.sort((a, b) => compareString(a.text, b.text));
  }

  private async fetchThenLoadPlanSetting() {
    try {
      const res = await getPlanSetting({ planId: this.id });
      this.planSetting = res;
      this.planSetting.uiSetting = this.planSetting.uiSetting || {
        bookingDetailBgcolor: '',
      };
    } catch (err) {
      this.$toast.error(
        this.$t('Failed to {do} due to {err}', {
          do: (this.$t('Fetch {msg}', {
            msg: this.$t('Plan setting'),
          }) as string).toLowerCase(),
          err: formatApiError(this.$i18n, err),
        }) as string,
        {
          icon: 'mdi-alert',
        }
      );
    }
  }

  private resetDialog() {
    this.dialog = false;
    this.dialogTextTitle = '';
    this.dialogTextFooter = '';
    this.$nextTick(() => {
      this.dialogConfirmHandler = this.resetDialog;
    });
  }

  private showDialogForUpdate() {
    this.dialogTextTitle = `${this.$t('Update {msg}', {
      msg: this.$t('Plan setting'),
    })}`;
    this.dialogTextFooter = `${this.$t('Is it OK?')}`;
    this.dialogConfirmHandler = () => {
      this.resetDialog();
      this.updatePlanSetting();
    };
    this.dialog = true;
  }

  private showDialogForResetEditing() {
    this.dialogTextTitle = `${this.$t('Reset')}`;
    this.dialogTextFooter = `${this.$t('Is it OK?')}`;
    this.dialogConfirmHandler = () => {
      this.resetDialog();
      this.startEditingPlanSetting();
    };
    this.dialog = true;
  }

  private showDialogForAbort() {
    this.dialogTextTitle = `${this.$t('Cancel {msg}', {
      msg: this.$t('Update {msg}', {
        msg: this.$t('Plan setting'),
      }),
    })}`;
    this.dialogTextFooter = `${this.$t('Is it OK?')}`;
    this.dialogConfirmHandler = () => {
      this.resetDialog();
      this.abortEditingPlanSetting();
    };
    this.dialog = true;
  }

  private startEditingPlanSetting() {
    this.editing = true;
    this.editingPlanSetting = JSON.parse(JSON.stringify(this.planSetting));
    this.enableMogiri = !!this.planSetting.mogiriSetting;

    const issuableFromDates: string[] = [];
    const issuableFromOptDates: string[] = [];
    const fromDateMenus: boolean[] = [];
    const fromOptDateMenus: boolean[] = [];
    this.editingPlanSetting.issuableFrom.forEach(f => {
      issuableFromDates.push(
        this.isRelativeFixedDate(f)
          ? stringFromIDate(f.relativeFixedDate!)!
          : this.isAbsoluteFixedDate(f)
          ? stringFromIDate(f.absoluteFixedDate!)!
          : ''
      );
      issuableFromOptDates.push(
        this.isRelativeFixedDate(f) && this.hasYearIncreamentBaseDate(f)
          ? stringFromIDate(f.yearIncreamentBaseDate!)!
          : ''
      );
      fromDateMenus.push(false);
      fromOptDateMenus.push(false);
    });
    this.editingPlanSetting.issuableFromDates = issuableFromDates;
    this.editingPlanSetting.issuableFromOptDates = issuableFromOptDates;
    this.fromDateMenus = fromDateMenus;
    this.fromOptDateMenus = fromOptDateMenus;
    const issuableToDates: string[] = [];
    const issuableToOptDates: string[] = [];
    const toDateMenus: boolean[] = [];
    const toOptDateMenus: boolean[] = [];
    this.editingPlanSetting.issuableTo.forEach(t => {
      issuableToDates.push(
        this.isRelativeFixedDate(t)
          ? stringFromIDate(t.relativeFixedDate!)!
          : this.isAbsoluteFixedDate(t)
          ? stringFromIDate(t.absoluteFixedDate!)!
          : ''
      );
      issuableToOptDates.push(
        this.isRelativeFixedDate(t) && this.hasYearIncreamentBaseDate(t)
          ? stringFromIDate(t.yearIncreamentBaseDate!)!
          : ''
      );
      toDateMenus.push(false);
      toOptDateMenus.push(false);
    });
    this.editingPlanSetting.issuableToDates = issuableToDates;
    this.editingPlanSetting.issuableToOptDates = issuableToOptDates;
    this.toDateMenus = toDateMenus;
    this.toOptDateMenus = toOptDateMenus;
    this.hasBookingDetailBgcolor = !!this.editingPlanSetting.uiSetting
      .bookingDetailBgcolor;

    this.editingPlanSetting.isActive = !this.editingPlanSetting.isInactive;

    if (!this.editingPlanSetting.mogiriSetting) {
      this.$set(this.editingPlanSetting, 'mogiriSetting', {
        bannerUrls: {
          details: '',
          valid: '',
          expired: '',
        },
        localedExtendedInfo: [],
      });
    }
  }

  private abortEditingPlanSetting() {
    this.editing = false;
    this.editingPlanSetting = {} as PlanSetting &
      WithIssuableDates &
      WithIsActive;
    this.fromDateMenus = [];
    this.fromOptDateMenus = [];
    this.toDateMenus = [];
    this.toOptDateMenus = [];
    this.hasBookingDetailBgcolor = false;
  }

  private async updatePlanSetting() {
    this.loading = true;
    AppModule.StartProgress();

    try {
      const updatePlanSetting = JSON.parse(
        JSON.stringify(this.editingPlanSetting)
      ) as PlanSetting;

      updatePlanSetting.issuableFrom.forEach(i => {
        if (this.isRelativeFixedDate(i)) {
          delete i.period;
          delete i.absoluteFixedDate;
        } else if (this.isAbsoluteFixedDate(i)) {
          delete i.period;
          delete i.relativeFixedDate;
        } else {
          delete i.relativeFixedDate;
          delete i.absoluteFixedDate;
        }
      });
      updatePlanSetting.issuableTo.forEach(i => {
        if (this.isRelativeFixedDate(i)) {
          delete i.period;
          delete i.absoluteFixedDate;
        } else if (this.isAbsoluteFixedDate(i)) {
          delete i.period;
          delete i.relativeFixedDate;
        } else {
          delete i.relativeFixedDate;
          delete i.absoluteFixedDate;
        }
      });
      if (!this.hasBookingDetailBgcolor) {
        updatePlanSetting.uiSetting.bookingDetailBgcolor = '';
      }
      delete (updatePlanSetting as any).issuableFromDates;
      delete (updatePlanSetting as any).issuableFromOptDates;
      delete (updatePlanSetting as any).issuableToDates;
      delete (updatePlanSetting as any).issuableToOptDates;

      if (!this.enableMogiri) {
        (updatePlanSetting.mogiriSetting as any) = null;
      }

      const req: IPutPlanSettingRequest = {
        planSettingId: updatePlanSetting.id,
        planId: updatePlanSetting.planId,
        issuingRules: updatePlanSetting.issuingRules,
        issuableFrom: updatePlanSetting.issuableFrom,
        issuableTo: updatePlanSetting.issuableTo,
        applyingRule: updatePlanSetting.applyingRule,
        printSpecs: updatePlanSetting.printSpecs,
        uiSetting: updatePlanSetting.uiSetting,
        isInactive: updatePlanSetting.isInactive,
        mogiriSetting: updatePlanSetting.mogiriSetting,
        version: updatePlanSetting.version,
      };

      await putPlanSetting(req);
    } catch (err) {
      this.$toast.error(
        this.$t('Failed to {do} due to {err}', {
          do: (this.$t('Update {msg}', {
            msg: this.$t('Plan setting'),
          }) as string).toLowerCase(),
          err: formatApiError(this.$i18n, err),
        }) as string,
        {
          icon: 'mdi-alert',
        }
      );
    }

    this.abortEditingPlanSetting();
    await this.fetchData(true);
    AppModule.StopProgress();
    this.loading = false;
  }

  private getPlanText(planId: string) {
    return this.plansByPlanId.has(planId)
      ? planToText(this.$i18n, this.plansByPlanId.get(planId)!)
      : '';
  }

  private UpdateIssuingRule(rule: IssuingRule) {
    if (this.isLimitedIssuingTicket(rule) && !rule.limitedIssuing) {
      // @ts-ignore
      rule.limitedIssuing = {
        ticketIds: [],
        maxIssuableKindQuantity: 0,
      };
    }
  }

  private isCannotPartialIssue(rule: IssuingRule) {
    return (rule.id as IssuingRuleId) === IssuingRuleId.CANNOT_PARTIALY_ISSUE;
  }

  private isLimitedIssuingTicket(rule: IssuingRule) {
    return (rule.id as IssuingRuleId) === IssuingRuleId.LIMITED_ISSUING;
  }

  private addEditingIssuingRule() {
    this.editingPlanSetting.issuingRules.push({
      id: IssuingRuleId.CANNOT_PARTIALY_ISSUE,
    });
  }

  private removeEditingIssuingRule(issuingRuleIndex: number) {
    this.editingPlanSetting.issuingRules.splice(issuingRuleIndex, 1);
  }

  private addEditingLocaledExtendedInfo() {
    this.editingPlanSetting.mogiriSetting.localedExtendedInfo?.push({
      lang: LanguageEnum.ENGLISH,
      extendedInfoList: [
        {
          title: '',
          description: '',
        },
      ],
    });
  }

  private removeEditingLocaledExtendedInfo(index: number) {
    this.editingPlanSetting.mogiriSetting.localedExtendedInfo?.splice(index, 1);
  }

  private addEditingExtendedInfoList(
    extendedInfoList: MogiriSettingPlanExtendedInfo[]
  ) {
    extendedInfoList.push({
      title: '',
      description: '',
    });
  }

  private removeEditingExtendedInfoList(
    extendedInfoList: MogiriSettingPlanExtendedInfo[],
    index: number
  ) {
    extendedInfoList.splice(index, 1);
  }

  private isRelativeFixedDate(date: IssuableDate) {
    return (
      (date.base as IssuableDateBaseDateTypeEnum) ===
      IssuableDateBaseDateTypeEnum.RELATIVE_FIXED_DATE
    );
  }

  private isAbsoluteFixedDate(date: IssuableDate) {
    return (
      (date.base as IssuableDateBaseDateTypeEnum) ===
      IssuableDateBaseDateTypeEnum.ABSOLUTE_FIXED_DATE
    );
  }

  private hasYearIncreamentBaseDate(date: IssuableDate) {
    return !!date.yearIncreamentBaseDate;
  }

  private addEditingIssuableFrom() {
    this.editingPlanSetting.issuableFrom.push({
      base: IssuableDateBaseDateTypeEnum.RELATIVE_FIXED_DATE,
      period: undefined,
      relativeFixedDate: stringToIDate(formatDate(new Date()))!,
    });
    this.editingPlanSetting.issuableFromDates.push(formatDate(new Date())!);
    this.editingPlanSetting.issuableFromOptDates.push('');
    this.fromDateMenus.push(false);
    this.fromOptDateMenus.push(false);
  }

  private removeEditingIssuableFrom(issuableFromIndex: number) {
    this.editingPlanSetting.issuableFrom.splice(issuableFromIndex, 1);
    this.editingPlanSetting.issuableFromDates.splice(issuableFromIndex, 1);
    this.editingPlanSetting.issuableFromOptDates.splice(issuableFromIndex, 1);
    this.fromDateMenus.splice(issuableFromIndex, 1);
    this.fromOptDateMenus.splice(issuableFromIndex, 1);
  }

  private handleIssuableFromRelativeFixedDateInput(
    date: string,
    issuableFromIndex: number
  ) {
    this.editingPlanSetting.issuableFrom[
      issuableFromIndex
    ].relativeFixedDate = stringToIDate(date)!;

    this.fromDateMenus[issuableFromIndex] = false;
  }

  private handleIssuableFromAbsoluteFixedDateInput(
    date: string,
    issuableFromIndex: number
  ) {
    this.editingPlanSetting.issuableFrom[
      issuableFromIndex
    ].absoluteFixedDate = stringToIDate(date)!;

    this.fromDateMenus[issuableFromIndex] = false;
  }

  private handleIssuableFromYearIncreamentBaseDateInput(
    date: string,
    issuableFromIndex: number
  ) {
    this.editingPlanSetting.issuableFrom[
      issuableFromIndex
    ].yearIncreamentBaseDate = stringToIDate(date)!;

    this.fromOptDateMenus[issuableFromIndex] = false;
  }

  private handleIssuableFromBaseInput(
    base: IssuableDateBaseDateTypeEnum,
    issuableFromIndex: number
  ) {
    if (
      (base as IssuableDateBaseDateTypeEnum) !==
        IssuableDateBaseDateTypeEnum.RELATIVE_FIXED_DATE &&
      !this.editingPlanSetting.issuableFrom[issuableFromIndex].period
    ) {
      this.editingPlanSetting.issuableFrom[issuableFromIndex].period = {
        count: 1,
        unit: TimePeriodUnitEnum.DAY,
      };
    }
  }

  private addEditingIssuableTo() {
    this.editingPlanSetting.issuableTo.push({
      base: IssuableDateBaseDateTypeEnum.RELATIVE_FIXED_DATE,
      period: undefined,
      relativeFixedDate: stringToIDate(formatDate(new Date()))!,
    });
    this.editingPlanSetting.issuableToDates.push(formatDate(new Date())!);
    this.editingPlanSetting.issuableToOptDates.push('');
    this.toDateMenus.push(false);
    this.toOptDateMenus.push(false);
  }

  private removeEditingIssuableTo(issuableToIndex: number) {
    this.editingPlanSetting.issuableTo.splice(issuableToIndex, 1);
    this.editingPlanSetting.issuableToDates.splice(issuableToIndex, 1);
    this.editingPlanSetting.issuableToOptDates.splice(issuableToIndex, 1);
    this.toDateMenus.splice(issuableToIndex, 1);
    this.toOptDateMenus.splice(issuableToIndex, 1);
  }

  private handleIssuableToRelativeFixedDateInput(
    date: string,
    issuableToIndex: number
  ) {
    this.editingPlanSetting.issuableTo[
      issuableToIndex
    ].relativeFixedDate = stringToIDate(date)!;

    this.toDateMenus[issuableToIndex] = false;
  }

  private handleIssuableToAbsoluteFixedDateInput(
    date: string,
    issuableToIndex: number
  ) {
    this.editingPlanSetting.issuableTo[
      issuableToIndex
    ].absoluteFixedDate = stringToIDate(date)!;

    this.toDateMenus[issuableToIndex] = false;
  }

  private handleIssuableToYearIncreamentBaseDateInput(
    date: string,
    issuableToIndex: number
  ) {
    this.editingPlanSetting.issuableTo[
      issuableToIndex
    ].yearIncreamentBaseDate = stringToIDate(date)!;

    this.toOptDateMenus[issuableToIndex] = false;
  }

  private handleIssuableToBaseInput(
    base: IssuableDateBaseDateTypeEnum,
    issuableToIndex: number
  ) {
    if (
      (base as IssuableDateBaseDateTypeEnum) !==
        IssuableDateBaseDateTypeEnum.RELATIVE_FIXED_DATE &&
      !this.editingPlanSetting.issuableTo[issuableToIndex].period
    ) {
      this.editingPlanSetting.issuableTo[issuableToIndex].period = {
        count: 1,
        unit: TimePeriodUnitEnum.DAY,
      };
    }
  }

  private addEditingPrintSpec() {
    this.editingPlanSetting.printSpecs.push({
      type: PlanSettingPrintSpecType.NONE,
      autoPrint: false,
    });
  }

  private removeEditingPrintSpec(printSpecIndex: number) {
    this.editingPlanSetting.printSpecs.splice(printSpecIndex, 1);
  }

  private getFixedDateText(fixedDate?: IDate) {
    return fixedDate ? stringFromIDate(fixedDate)!.slice(5) : '';
  }

  private getFixedDateWithYearText(fixedDate?: IDate) {
    return fixedDate ? stringFromIDate(fixedDate)! : '';
  }

  private getPeriodText(period?: TimePeriod) {
    return period
      ? `${period.count} ${this.$t(
          'TimePeriodUnitEnum.' + (period.unit as string)
        )}`
      : '';
  }

  private stringIsNumber(v?: string) {
    return v !== void 0 && !isNaN(stringToNumber(v));
  }

  private getRequiredRules(
    msg: any,
    exception: (v: any) => boolean = () => false
  ) {
    return [
      (v: string) =>
        exception(v) ||
        !!v ||
        (this.$t('{msg} is required', {
          msg: this.$te(msg) ? this.$t(msg) : msg,
        }) as string),
    ];
  }

  private getMinRules(
    msg: string,
    min?: number,
    exception: (v: any, min: any) => boolean = () => false
  ) {
    return [
      (v: number) =>
        exception(v, min) ||
        v >= min! ||
        (this.$t('{msg} must be equal or greater than {num}', {
          msg: this.$t(msg),
          num: min,
        }) as string),
    ];
  }
}
